import React from 'react';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';

function TrendBadge({ current, previous }) {
  if (!previous || previous === 0) return null;
  const pctChange = ((current - previous) / previous) * 100;
  if (Math.abs(pctChange) < 1) {
    return <span className="inline-flex items-center gap-0.5 text-xs text-stone-400"><Minus className="h-3 w-3" />0%</span>;
  }
  const isUp = pctChange > 0;
  return (
    <span className={`inline-flex items-center gap-0.5 text-xs font-medium ${isUp ? 'text-emerald-600' : 'text-red-500'}`}>
      {isUp ? <TrendingUp className="h-3 w-3" /> : <TrendingDown className="h-3 w-3" />}
      {isUp ? '+' : ''}{pctChange.toFixed(0)}%
    </span>
  );
}

export function SummaryCards({ data }) {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4" data-testid="analytics-summary-cards">
      <div className="card-surface p-5 border-l-4 border-l-[#D4AF37]">
        <p className="text-xs text-stone-500 uppercase tracking-wider mb-1">Bookings</p>
        <div className="flex items-end gap-2">
          <p className="text-2xl font-heading font-bold text-[#1A1A1A]" data-testid="summary-bookings">
            {data.confirmed_bookings}
          </p>
          <TrendBadge current={data.confirmed_bookings} previous={data.prev_confirmed_bookings} />
        </div>
        <p className="text-xs text-stone-400 mt-1">{data.cancelled_bookings} cancelled</p>
      </div>

      <div className="card-surface p-5 border-l-4 border-l-emerald-500">
        <p className="text-xs text-stone-500 uppercase tracking-wider mb-1">Revenue</p>
        <div className="flex items-end gap-2">
          <p className="text-2xl font-heading font-bold text-emerald-600" data-testid="summary-revenue">
            £{data.total_revenue.toFixed(0)}
          </p>
          <TrendBadge current={data.total_revenue} previous={data.prev_total_revenue} />
        </div>
        <p className="text-xs text-stone-400 mt-1">Avg £{data.average_booking_value.toFixed(0)}/booking</p>
      </div>

      <div className="card-surface p-5 border-l-4 border-l-blue-500">
        <p className="text-xs text-stone-500 uppercase tracking-wider mb-1">Clients</p>
        <p className="text-2xl font-heading font-bold text-[#1A1A1A]" data-testid="summary-clients">
          {data.unique_clients}
        </p>
        <p className="text-xs text-stone-400 mt-1">
          {data.new_clients} new · {data.returning_clients} returning
        </p>
      </div>

      <div className="card-surface p-5 border-l-4 border-l-amber-400">
        <p className="text-xs text-stone-500 uppercase tracking-wider mb-1">Rebooking Rate</p>
        <p className="text-2xl font-heading font-bold text-[#D4AF37]" data-testid="summary-rebooking">
          {data.rebooking_rate}%
        </p>
        <p className="text-xs text-stone-400 mt-1">
          {data.rating > 0 ? `★ ${data.rating} (${data.review_count})` : 'No reviews yet'}
        </p>
      </div>
    </div>
  );
}
